.controls {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
}

.header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

.sectionTitle {
  margin: 0;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgb(233 233 237 / 0.45);
}

.hint {
  margin: 0;
  font-size: 11px;
  color: rgb(233 233 237 / 0.35);
}

.blurb {
  margin: 3px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: rgb(233 233 237 / 0.4);
}

.dialRow {
  display: flex;
  gap: 16px;
  align-items: center;
}

/* — label size — */

.sliderGroup {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.sliderHead {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.label {
  margin-right: auto;
  font-size: 12px;
  color: rgb(233 233 237 / 0.7);
}

.readout {
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  color: rgb(233 233 237 / 0.42);
}

.range {
  appearance: none;
  -webkit-appearance: none;
  height: 26px;
  width: 100%;
  background: transparent;
  margin: 0;
}

.range::-webkit-slider-runnable-track {
  height: 2px;
  background: var(--color-neutral-800);
  border-radius: 2px;
}

.range::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 19px;
  height: 19px;
  margin-top: -8.5px;
  border-radius: 50%;
  background: var(--color-bg);
  border: 1.5px solid var(--color-accent);
  box-shadow: 0 0 0 4px rgb(145 132 217 / 0.14);
}

.range::-moz-range-track {
  height: 2px;
  background: var(--color-neutral-800);
  border-radius: 2px;
}

.range::-moz-range-thumb {
  width: 19px;
  height: 19px;
  border-radius: 50%;
  background: var(--color-bg);
  border: 1.5px solid var(--color-accent);
  box-shadow: 0 0 0 4px rgb(145 132 217 / 0.14);
}

/* — primary action — */

.actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.actions button {
  min-height: 46px;
  font-size: 15px;
  margin: 0;
}

.caption {
  margin: 0;
  font-size: 11px;
  color: rgb(233 233 237 / 0.35);
  text-align: center;
}

/* — empty-state explainers — */

.placeholder {
  display: flex;
  flex-direction: column;
  gap: 4px;
  opacity: 0.45;
}

.steps {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: rgb(233 233 237 / 0.7);
}

@media (min-width: 900px) {
  .controls {
    gap: 16px;
  }

  .header {
    display: block;
  }

  .actions {
    margin-top: auto;
  }

  .actions button {
    min-height: 44px;
  }

  .placeholder {
    opacity: 0.5;
    gap: 4px;
  }
}
